<div class="container">
    <div class="structure-container" *ngIf="structures.rows.length; else noProductsTemplate">
        @for (structure of structures.rows; track $index) {
        <div class="wrapper">
            <div class="inner-wrapper">
                <div class="structure" (click)="goToMyStuctureDesign(structure.id)">
                    <div class="checkbox" *ngIf="structure.status === structureStatus.Saved">
                        <mat-checkbox
                            [checked]="selectedStructureIds.has(structure.id)"
                            (click)="$event.stopPropagation()"
                            (change)="onCheckboxChange($event, structure.id)"
                        ></mat-checkbox>
                    </div>
                    <mat-icon class="actions-icon" (click)="openPropertiesDialog(structure); $event.stopPropagation()"
                        >settings</mat-icon
                    >
                    <div class="structure-details">
                        <span class="structure-name">{{ structure.structureName }}</span>
                        <span>{{ structure.updatedAt | date: "dd MMM YYYY" }}</span>
                        <span class="structure-details-status">{{ structure.status }}</span>
                    </div>
                    <img class="structure-image" [src]="structure.imageurl" />
                </div>
                <!-- Show Publish/Delete buttons only for SAVED structures -->
                <div class="button-container" *ngIf="structure.status === structureStatus.Saved">
                    <app-button
                        variant="hero"
                        [disabled]="!isStructureSelected(structure.id)"
                        (onClick)="onPublish(structure.id, structure.status!)"
                    >
                        {{ "structure.button.publishBtn" | translate }}
                    </app-button>
                    <app-button
                        variant="white"
                        buttonClass="shadow-btn"
                        [disabled]="!isStructureSelected(structure.id)"
                        (onClick)="onDelete(structure.id, structure.status!)"
                    >
                        {{ "structure.button.deleteBtn" | translate }}
                    </app-button>
                </div>
            </div>
        </div>
        }
    </div>
    <div class="view-more-container" *ngIf="showViewMoreButton">
        <button class="save-btn customise-btn" mat-flat-button (click)="onViewMore()">
            {{ "structure.button.viewMoreBtn" | translate }}
        </button>
    </div>
    <ng-template #noProductsTemplate>
        <div class="empty-structure" *ngIf="!loadingStructure">
            <div class="image-container">
                <mat-icon
                    svgIcon="emptyStructure"
                    class="emptyStructureIcon"
                    aria-hidden="false"
                    aria-label="Empty Structure"
                />
            </div>
            <div class="message">
                <h2>{{ "structure.noStructure.noStructureFound" | translate }}</h2>
                <div *ngIf="!structures.totalCount">
                    <p>{{ "structure.noStructure.noStructureFoundMessage" | translate }}</p>
                    <div class="button">
                        <app-button variant="hero" (click)="goTodesigner()">
                            {{ "structure.button.goToDesigner" | translate }}
                        </app-button>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>
